// Local time (no trailing Z). Any layout saved before this datetime will be reset.
export const DASHBOARD_FORCE_RESET_DATE = '2026-06-09T00:00:00.000';
